//import { EnvName } from '@libs/enums/env.enum';

import { az } from 'date-fns/locale';

export const environment = {
  production: true,
  apiUrl: '/api',
  //env: EnvName.PROD,
  minPasswordLength: 12,
  appName: 'POWER+',
  azureClientId: '31ab358b-236d-48e8-8908-e615f3acc9d2',
  azureTenantId: '8dfe4506-fdae-4f04-839a-3adf8752eabb',
  azureAdEndpoint: 'https://login.microsoftonline.com/',
  ersDomainMatchString: 'ers-cat|black-hill|ers|localhost',
  weatherApiKey: '6d497680b0c0478f8b8214420232405',
  supportEmail: 'business.services@prshold.com',
  azureConnectionString:
    'InstrumentationKey=96926285-826e-4f30-b2cf-5b0b102cb4f8;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/;ApplicationId=72b5ff3b-e41f-4ad4-a102-1dc1b36fea57',
};
